import { FilterTimeFrameValue } from "server/config-api/index.js";
import { Granularity } from "server/dwhApi/common.js";

import { ViewWithLoader } from "../ViewWithLoader";
import { RecyclingRate } from "./recyclingRate";
import type { ViewType } from "./recyclingRate/constants";
import type { RecyclingRatePoint } from "./recyclingRate/types";
import { WasteAmounts } from "./wasteAmounts";
import type {
  WasteAmountsPoint,
  WasteAmountsStream,
} from "./wasteAmounts/types";

type Props = {
  granularity: Granularity;
  period: FilterTimeFrameValue;
  showLoadingState: boolean;
  recyclingRateData: RecyclingRatePoint[];
  wasteAmountsData: WasteAmountsPoint[];
  wasteAmountsStreams: WasteAmountsStream[];
  recyclingRateSubtitle: string;
  wasteAmountsSubtitle: string;
  viewType: ViewType;
  target: number;
  updateTarget: (value: number) => void;
  showCompareYear: boolean;
  setShowCompareYear: (value: boolean) => void;
  showPortfolioAverage?: boolean;
  setShowPortfolioAverage?: (value: boolean) => void;
};

export const TrendView: React.FC<Props> = ({
  showLoadingState,
  recyclingRateData,
  wasteAmountsData,
  wasteAmountsStreams,
  recyclingRateSubtitle,
  wasteAmountsSubtitle,
  viewType,
  target,
  updateTarget,
  showCompareYear,
  setShowCompareYear,
  showPortfolioAverage,
  setShowPortfolioAverage,
}) => {
  return (
    <ViewWithLoader isLoading={showLoadingState}>
      <div className="mt-[20px]">
        <RecyclingRate
          data={recyclingRateData}
          subtitle={recyclingRateSubtitle}
          viewType={viewType}
          target={target}
          updateTarget={updateTarget}
          showCompareYear={showCompareYear}
          setShowCompareYear={setShowCompareYear}
          showPortfolioAverage={showPortfolioAverage}
          setShowPortfolioAverage={setShowPortfolioAverage}
        />
        <div className="bg-grey2 my-3 h-[1.1px] w-full" />
        <WasteAmounts
          data={wasteAmountsData}
          wasteStreams={wasteAmountsStreams}
          subtitle={wasteAmountsSubtitle}
        />
      </div>
    </ViewWithLoader>
  );
};
